import React, { Component, Fragment } from 'react';
import Navigation from '../components/Navigation';
import { translate } from 'react-i18next';
import { MediaTextsEditor as Editor } from '../components/MediaTextsEditor';
import { Col, Row } from 'react-bootstrap';
import config from '../config';
import axios from 'axios';
import { Link } from 'react-router-dom';
import './EditMediaText.css';

export class EditTemplateMediaText extends Component {
    constructor(props) {
        super(props);

        this.state = {
            media: null,
            mediaLibrary: null
        };
    }

    componentDidMount() {
        this.loadMediaFromServer();
        this.loadMediaLibraryFromServer();
    }

    loadMediaFromServer() {
        const { mediaUUID } = this.props.match.params;

        let self = this;
        axios
            .get(`${config.baseURL}/media/${mediaUUID}`, {})
            .then(function(response) {
                self.setState({ media: response.data.media });
            })
            .catch(function(error) {
                console.error('Error loading media:', error);
            });
    }

    loadMediaLibraryFromServer() {
        const { mediaLibraryUUID } = this.props.match.params;

        let self = this;
        axios
            .get(`${config.baseURL}/medialibraries/${mediaLibraryUUID}`, {})
            .then(function(response) {
                self.setState({ mediaLibrary: response.data.medialibrary });
            })
            .catch(function(error) {
                console.error('Error loading media library:', error);
            });
    }

    render() {
        const { t } = this.props;
        const { mediaLibraryUUID } = this.props.match.params;

        document.title = `MySign Digital Screen Solutions | ${t(
            'EditTemplateMediaText.title'
        )}`;

        return (
            <div className="EditMediaText">
                <div id="wrapper">
                    <Navigation props={this.props} />
                    <div id="content-wrapper">
                        <Row>
                            <Col lg={12}>
                                <h1 className="page-header">
                                    {t('EditTemplateMediaText.title')}
                                    {this.state.media && (
                                        <small> - {this.state.media.name}</small>
                                    )}
                                </h1>

                                <ol className="breadcrumb">
                                    <li>
                                        <i className="fas fa-images" />{' '}
                                        <Link to={`/templatelibraries`}>
                                            {t('Navigation.templatelibraries')}
                                        </Link>
                                    </li>
                                    <li>
                                        <i className="fas fa-images" />{' '}
                                        <Link
                                            to={`/templatelibraries/${mediaLibraryUUID}`}
                                        >
                                            {t('TemplateMediaLibrary.title')}
                                        </Link>
                                    </li>
                                    <li className="active">
                                        <i className="fas fa-text-width" />{' '}
                                        {t('EditTemplateMediaText.breadcrumb')}
                                    </li>
                                </ol>
                                {this.state.mediaLibrary && (
                                    <Editor
                                        match={{
                                            ...this.props.match,
                                            params: {
                                                ...this.props.match.params,
                                                uuid: this.state.mediaLibrary.organisationUUID
                                            }
                                        }}
                                        media={this.state.media}
                                    />
                                )}
                            </Col>
                        </Row>
                    </div>
                </div>
            </div>
        );
    }
}

export default translate('translations')(EditTemplateMediaText);
